import { render, staticRenderFns } from "./AidocList.vue?vue&type=template&id=bfb2fe5e&scoped=true"
import script from "./AidocList.vue?vue&type=script&lang=js"
export * from "./AidocList.vue?vue&type=script&lang=js"
import style0 from "./AidocList.vue?vue&type=style&index=0&id=bfb2fe5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb2fe5e",
  null
  
)

export default component.exports